import React from "react";
import { Sparkles, CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LAGAN_ITEMS, BUSINESS } from "@/data/business";

const IMG =
  "https://images.pexels.com/photos/35069916/pexels-photo-35069916.jpeg";

export default function LaganCombo() {
  const waMsg = encodeURIComponent(
    "Hello Bhadani Electronics, I'm interested in the Lagan Combo Offer (11 items at ₹29,990). Please share details."
  );
  return (
    <section id="offer" className="bg-slate-50 py-16 md:py-24" data-testid="lagan-section">
      <div className="container-b">
        <div className="mb-10 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-amber-100 px-3 py-1 text-xs font-bold uppercase tracking-[0.2em] text-amber-700">
              <Sparkles className="h-3.5 w-3.5" /> Wedding Season Special
            </div>
            <h2 className="font-heading mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
              Lagan Combo Offer
            </h2>
            <p className="mt-3 max-w-2xl text-base text-slate-600">
              A complete home starter kit for the season of new beginnings — 11 essential items
              covering electronics <span className="font-semibold text-slate-900">and</span> furniture,
              bundled at one unbeatable price.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5 lg:gap-8">
          <div className="lg:col-span-3">
            <div className="lagan-glow relative overflow-hidden rounded-3xl border border-amber-200 bg-white">
              <div className="relative">
                <img
                  src={IMG}
                  alt="Wedding season combo"
                  className="h-72 w-full object-cover sm:h-96"
                  data-testid="lagan-image"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent" />
                <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between text-white">
                  <div>
                    <div className="text-xs font-bold uppercase tracking-[0.25em] text-amber-300">Combo Price</div>
                    <div className="font-heading mt-1 text-4xl font-extrabold sm:text-5xl" data-testid="lagan-price">
                      ₹29,990<span className="text-xl font-semibold">/-</span>
                    </div>
                    <div className="mt-1 text-sm text-white/80">for all 11 items · inclusive combo</div>
                  </div>
                  <div className="hidden rounded-2xl bg-white/15 px-4 py-3 text-right backdrop-blur-md sm:block">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-200">Items</div>
                    <div className="font-heading text-3xl font-extrabold">11</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="h-full rounded-3xl border border-slate-200 bg-white p-6 sm:p-7">
              <h3 className="font-heading text-xl font-bold text-slate-900">What&apos;s included</h3>
              <p className="mt-1 text-sm text-slate-500">Everything a new home needs, from day one.</p>

              <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2" data-testid="lagan-items-list">
                {LAGAN_ITEMS.map((item, idx) => (
                  <li
                    key={item}
                    className="flex items-start gap-2 text-sm text-slate-700"
                    data-testid={`lagan-item-${idx}`}
                  >
                    <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-blue-700" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 flex flex-col gap-3">
                <Button
                  asChild
                  className="rounded-full bg-amber-500 text-white hover:bg-amber-600"
                  data-testid="lagan-whatsapp-btn"
                >
                  <a
                    href={`https://wa.me/${BUSINESS.waNumber}?text=${waMsg}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Book on WhatsApp <ArrowRight className="ml-1 h-4 w-4" />
                  </a>
                </Button>
                <Button
                  asChild
                  variant="outline"
                  className="rounded-full border-slate-300 text-slate-900 hover:bg-slate-50"
                  data-testid="lagan-enquire-btn"
                >
                  <a href="#contact">Enquire via form</a>
                </Button>
                <p className="mt-1 text-xs text-slate-500">
                  * Brands and models may vary based on availability. Contact store for detailed combo list.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
